import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { Card, Typography, Box, Divider } from "@mui/material";
import mainStyle from "../mainStyle.module.scss";
import useDataSourceManager from "hooks/useDataSourceManager";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";
import GlobalAlert from "components/Notification";

const ControllerInvition = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [acceptUuid, setAcceptUuid] = useState(uuidv4());
  const [isAccepting, setIsAccepting] = useState(false);
  const [alertInfo, setAlertInfo] = useState({
    open: false,
    severity: "",
    message: "",
  });

  const email = localStorage.getItem("invitationEmail");
  const invitationId = localStorage.getItem("invitationId");
  const { dataMap, getData, decodeTokenData, sendRequest, sendBatch } =
    useDataSourceManager();

  const acceptInvitation = () => {
    if (isAccepting) return;

    setIsAccepting(true);

    sendRequest("/me/invitations/:invitationId/accept.update", acceptUuid, {
      invitationId,
    });
  };

  useEffect(() => {
    const meAcceptResponse = getData(acceptUuid);
    if (!meAcceptResponse) return;

    setIsAccepting(false);

    if (meAcceptResponse?.data) {
      localStorage.removeItem("invitationEmail");
      localStorage.removeItem("invitationId");
      localStorage.removeItem("organizationName");
      navigate("/realms");
      return;
    }

    setAlertInfo({
      open: true,
      severity: "error",
      message: meAcceptResponse?.message,
    });
  }, [dataMap]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      marginTop="100px"
    >
      <Card className={mainStyle["controller-invitation-card"]}>
        <Typography
          fontSize={theme.typography.customFontSize[5]}
          color={theme.palette.primary.main}
          fontWeight={theme.typography.customFontWeight[3]}
          letterSpacing="-1"
          fontFamily={theme.typography.fontFamily}
          marginTop="40px"
        >
          Invitation
        </Typography>
        <Divider sx={{ mb: 3, mt: 2 }} />

        <Typography
          sx={{
            mb: 1,
            color: theme.palette.primary.black,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.customFontSize[3],
            maxWidth: "828px",
            wordBreak: "break-word",
            whiteSpace: "normal",
            mx: "auto",
          }}
        >
          You have been invited to join the Nuclias Unity to manage the
          organization. Please click the button below to accept the invitation
          and activate your cloud user account associated with:
          <Typography
            component="span"
            fontWeight={theme.typography.customFontWeight[1]}
          >
            {email}
          </Typography>
          .
        </Typography>

        <Box mt={4} display="flex" justifyContent="center" gap={2}>
          <OutlineButton
            onClick={() => navigate("/")}
            sx={{ marginRight: "20px" }}
            width="186px"
            height="42px"
            disabled={isAccepting}
          >
            Cancel
          </OutlineButton>

          <SolidButton
            onClick={acceptInvitation}
            width="186px"
            height="42px"
            loading={isAccepting}
            disabled={isAccepting}
          >
            Accept Invitation
          </SolidButton>
        </Box>
      </Card>
      <GlobalAlert
        open={alertInfo.open}
        severity={alertInfo.severity}
        message={alertInfo.message}
        onClose={() => setAlertInfo((prev) => ({ ...prev, open: false }))}
      />
    </Box>
  );
};
export default ControllerInvition;
